import { toolSearch } from '@erikdakoda/tool-set/ai-tools/toolSearch';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(toolSearch);
